var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLensA(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 473.934,
    height: 654.532,
    viewBox: "0 0 473.934 654.532",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3",
    d: "M236.967 0.573242C302.174 0.573242 361.259 37.0743 404.063 96.1904C446.868 155.306 473.36 237.002 473.36 327.267C473.36 417.531 446.868 499.226 404.063 558.342C361.259 617.458 302.174 653.959 236.967 653.959C171.76 653.959 112.675 617.458 69.8701 558.342C27.066 499.226 0.57332 417.531 0.573242 327.267C0.573242 237.002 27.0659 155.306 69.8701 96.1904C112.675 37.0743 171.76 0.573316 236.967 0.573242Z",
    stroke: "url(#paint0_linear_0_5)",
    strokeWidth: 1.14639
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_5",
    x1: 236.967,
    y1: 0,
    x2: 236.967,
    y2: 654.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    style: {
      stopColor: "#D9D9D9",
      stopColor: "color(display-p3 0.8510 0.8510 0.8510)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616",
    style: {
      stopColor: "#161616",
      stopColor: "color(display-p3 0.0863 0.0863 0.0863)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLensA);
export default __webpack_public_path__ + "static/media/lens-a.0e718915eed9242fea2382b9488e3490.svg";
export { ForwardRef as ReactComponent };